import { render, staticRenderFns } from "./taskToApproveLine.vue?vue&type=template&id=86388e7a&scoped=true&"
import script from "./taskToApproveLine.vue?vue&type=script&lang=js&"
export * from "./taskToApproveLine.vue?vue&type=script&lang=js&"
import style0 from "./taskToApproveLine.vue?vue&type=style&index=0&id=86388e7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86388e7a",
  null
  
)

export default component.exports